import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControlLabel, Switch, Box } from "@mui/material";

export default function SizeFlavorEditDialog(props) {
  const { open, onClose, selectedCell } = props;
  const [allow, setAllow] = useState(true);
  const [amount, setAmount] = useState("");

  // Update state when selectedCell changes
  useEffect(() => {
    if (selectedCell) {
      setAllow(String(selectedCell.value.allow) === "true");
      setAmount(selectedCell.value.amount || "");
    }
  }, [selectedCell]);

  const handleSubmit = (mode) => {
    let override = selectedCell?.optionData?.override || {};

    if (mode === "delete") {
      console.log("delete", selectedCell.sizeData.name);
      console.log("override", override);
      delete override.size[selectedCell.sizeData.name];
      if (Object.keys(override.size).length === 0) {
        delete override.size;
      }
    } else {
      override = {
        size: {
          ...(override?.size || {}),
          [selectedCell.sizeData.name]: {
            allow,
            amount
          }
        }
      };
    }

    props.onSubmit({
      productSize: selectedCell.sizeData.name,
      variantOption: selectedCell.optionData.name,
      override
    });
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {selectedCell?.optionData?.name} | {selectedCell?.sizeData?.name}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <FormControlLabel control={<Switch checked={allow} onChange={(e) => setAllow(e.target.checked)} color="primary" />} label="Active" />
          <TextField
            label="Amount ($)"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            variant="outlined"
            fullWidth
            disabled={!allow}
            inputProps={{ step: "0.01", min: "0" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button fullWidth color="error" variant="outlined" onClick={() => handleSubmit("delete")}>
          Delete Override
        </Button>
        <Button fullWidth onClick={() => handleSubmit("save")} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
